import React from 'react';
import { SpecialistList as Specialist } from '../../../../models/Specialist';
import { handleSpecialtiesWithExpertises } from '../../../../utils/specialist-utils';
import { SearchResult } from '../SearchResult';

// import { Container } from './styles';

type SpecialistListProps = {
  specialists: Specialist[];
  handleSelectResource: (item: Specialist) => void;
};

export const SpecialistList: React.FC<SpecialistListProps> = ({ specialists, handleSelectResource, ...rest }) => {
  return (
    <>
      {specialists?.map(item => (
        <SearchResult
          {...rest}
          key={item.id}
          title={item.name}
          subtitle={handleSpecialtiesWithExpertises(item.specialties)}
          icon={item.profile_picture}
          type="SPECIALIST"
          onClick={() => handleSelectResource(item)}
        />
      ))}
    </>
  );
};
